import axios from "axios";
import type { OCRValidationInput, OCRValidationResponse } from "@/types/ocr";

const API_URL = import.meta.env.VITE_API_URL || "http://10.113.1.240:8000/api/v1";

/**
 * Valida um comprovante via OCR (endpoint público, não precisa autenticação).
 * Fail-open: se o OCR service estiver down, retorna sucesso=false mas não lança.
 */
export async function validarComprovanteOCR(
  input: OCRValidationInput
): Promise<OCRValidationResponse> {
  const formData = new FormData();
  formData.append("imagem", input.imagem, "comprovante.jpg");
  if (input.valor_esperado !== undefined) {
    formData.append("valor_esperado", String(input.valor_esperado));
  }
  if (input.terminal_esperado !== undefined) {
    formData.append("terminal_esperado", input.terminal_esperado);
  }

  const response = await axios.post<OCRValidationResponse>(
    `${API_URL}/public/lotese/validar-ocr`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 15000,
    }
  );
  return response.data;
}
